import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Suspense } from "react";
import { PageLoader } from "./components/page-loader";
import { createLazyComponent } from "./utils/lazyLoad";

const LandingPageLayout = createLazyComponent(
  () =>
    import("./page/landing-layout").then((module) => ({
      default: module.LandingPageLayout,
    })),
  "layout-landing"
);

const LandingPage = createLazyComponent(
  () => import("./page/landing"),
  "page-landing"
);

const ServicesPage = createLazyComponent(
  () =>
    import("./page/services").then((module) => ({
      default: module.ServicesPage,
    })),
  "page-services"
);

const ContactUsPage = createLazyComponent(
  () =>
    import("./page/contact-us").then((module) => ({
      default: module.ContactUsPage,
    })),
  "page-contact"
);

const DocumentsPage = createLazyComponent(
  () => import("./page/documents.page"),
  "page-documents"
);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route element={<LandingPageLayout />}>
            <Route index element={<LandingPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="contact-us" element={<ContactUsPage />} />
            <Route
              path="documents"
              element={<DocumentsPage baseUrl="/documents" />}
            />
            <Route
              path="documents/:documentId"
              element={<DocumentsPage baseUrl="/documents" />}
            />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
